import { YesOrNoModel } from './types/yesOrNo';
import { ListModel } from './types/list';
import { EmailModel } from './types';
import { EmptyBranch } from './validators/models/branch/instance';

export const EmptyYesOrNo = (): YesOrNoModel => ({
  name: '',
  value: '',
});

export const EmptyList = <t>(): ListModel<t> => ({
  branch: EmptyBranch(),
  items: [],
});

export const EmptyEmail = (): EmailModel => ({
  name: '',
  value: '',
});

export const EmptyEmailInstance = EmptyEmail();
export const EmptyYesOrNoInstance = EmptyYesOrNo();
export const EmptyListInstance = EmptyList();
